/**
 * Delivery-option registrations — imported eagerly by ModuleNotificationBlock.
 *
 * Every module delivery option (see `../moduleDeliveryOptions.ts`) is registered
 * from THIS file, at import time. It must not be registered from a module's own
 * settings page: the central /settings?tab=notifications tab renders blocks for
 * modules whose settings page was never imported, so a lazily-registered option
 * would be missing there — exactly the one-mount asymmetry the slot exists to
 * remove.
 *
 * The imported control must not import a settings PAGE, or this barrel pulls a
 * page (and its route-level data hooks) into every notification mount.
 */
import { MessagingEmailDelay } from '../../../modules/messaging/components/MessagingEmailDelay';
import { DailySummarySendHour } from '../../../modules/procurement/components/DailySummarySendHour';
import { registerModuleDeliveryOption } from '../moduleDeliveryOptions';

// The hour the daily procurement summary goes out, in the reader's own timezone.
// Its on/off is the `general` / `outstanding_processes_digest` catalog row above it
// — this is only the shape of the delivery (WI 104d5eff).
registerModuleDeliveryOption('procurement', {
  id: 'daily-summary-send-hour',
  Component: DailySummarySendHour,
});

// Messaging's email grace period — the last survivor of the module's retired
// bespoke notification table (WI 0ad86039). Everything else it held became a
// catalog event or a global gate on user_notification_settings.
registerModuleDeliveryOption('messaging', {
  id: 'email-delay-minutes',
  Component: MessagingEmailDelay,
});
